import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Settings from "components/dashboard/Settings";
import ApprovalPage from "pages/dashboard/global-admin/ApprovalPage";
import AssistantManagerPage from "pages/dashboard/global-admin/AssistantManagerPage";
import UsageMonitorPage from "pages/dashboard/global-admin/UsageMonitorPage";
import RegionalAdminsPage from "pages/dashboard/global-admin/RegionalAdminsPage";
import HipaaComplianceCalendarPage from "pages/dashboard/global-admin/HipaaComplianceCalendarPage";
import SystemHealthPage from "pages/dashboard/global-admin/SystemHealthPage";
import PromptsManagerPage from "pages/dashboard/admin/prompts/PromptsManagerPage";
import AllFilesPage from "pages/dashboard/admin/AllFilesPage";
import ChartMindPage from "pages/dashboard/professional/ChartMindPage";
import MyChartsPage from "pages/dashboard/professional/MyChartsPage";
import PeerViewPage from "pages/dashboard/professional/PeerViewPage";
import DashboardLayout from "components/dashboard/DashboardLayout";
import { MorningReportCaseMaker } from "features/morningReport/MorningReportPages";
import { useAuth } from "hooks/useAuth";
import { PromptsManagerProvider } from "context/PromptsManager";
import { ChartMindSessionProvider } from "context/ChartMindSession";
import HomePage from "pages/dashboard/HomePage";

/**
 * Routes for platform super-admins (custom claim admin + role global_admin).
 * Includes ChartMind for testing the same flows as professional users.
 */
const GlobalAdminRoutes = () => {
  const { user, subscription } = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const isChartMindSessionList = /\/chartmind\/sessions\/?$/.test(path);
  const chartMindFullWidth =
    (path.includes("/chartmind") || path.includes("/peerview")) &&
    !isChartMindSessionList;

  return (
    <DashboardLayout fullWidth={chartMindFullWidth}>
      <PromptsManagerProvider>
        <ChartMindSessionProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/settings"
              element={<Settings uid={user?.uid} subscription={subscription} />}
            />
            <Route path="/admin/approval" element={<ApprovalPage />} />
            <Route
              path="/admin/regional-admins"
              element={<RegionalAdminsPage />}
            />
            <Route
              path="/admin/hipaa-compliance"
              element={<HipaaComplianceCalendarPage />}
            />
            <Route path="/admin/assistants" element={<AssistantManagerPage />} />
            <Route path="/admin/usage" element={<UsageMonitorPage />} />
            <Route path="/admin/health" element={<SystemHealthPage />} />
            {/* One route, so opening a case's dialog keeps the list behind it mounted. */}
            <Route
              path="/admin/morning-report-cases/:caseId?"
              element={<MorningReportCaseMaker />}
            />
            <Route path="/prompts" element={<PromptsManagerPage />} />
            <Route path="/files" element={<AllFilesPage />} />
            <Route path="/diskusage" element={<Navigate to="/dashboard/files" replace />} />
            <Route
              path="/chartmind"
              element={
                <ChartMindPage key={location.state?.key || location.pathname} />
              }
            />
            <Route path="/chartmind/sessions" element={<MyChartsPage />} />
            <Route path="/peerview" element={<PeerViewPage />} />
            <Route
              path="/chartmind/:sessionId"
              element={
                <ChartMindPage key={location.state?.key || location.pathname} />
              }
            />
            <Route
              path="*"
              element={<Navigate to="/dashboard/prompts" replace />}
            />
          </Routes>
        </ChartMindSessionProvider>
      </PromptsManagerProvider>
    </DashboardLayout>
  );
};

export default GlobalAdminRoutes;
